import { IResponse } from '@zmedia/bm-soccer-ui/interface';
import { getWithPath } from '@zmedia/bm-soccer-ui/utils/http';

const API_PATH = {
    GET_DETAIL: '/standing/get/detail',

};

export const StandingService = {
    getDetail: (params: any): Promise<IResponse<any>> => {
        return getWithPath(API_PATH.GET_DETAIL, params);
    },
};

export default StandingService;
